export { default as api } from './api'
export { default as bytesToSize } from './bytesToSize'
export { default as capitalize } from './capitalize'
export { getCookie, removeCookie, setCookie } from './cookies'
export { dateToHuman, datter, displayer } from './dateFormatter'
export { isEmailConfirmationRequired } from './emailConfirmation'
export { default as errorHandler } from './errorHandler'
export { default as fetcher } from './fetcher'
export { getFingerprint } from './fingerprint'
export { default as formatNumberWithCheckDigit } from './formatNumberWithCheckDigit'
export { getProductInfo } from './getProductInfo'
export { default as getShowcasesFromGrades } from './getShowcasesFromGrades'
export { default as hasDistinctChannel } from './hasDistinctChannel'
export { default as kebabCase } from './kebabCase'
export * as masks from './masks'
export { default as SEO } from './next-seo.config'
export { default as notificationHandler } from './notificationHandler'
export * as productOptions from './productOptions'
export { getSession, removeSession, setSession } from './session'
export { getAsyncStorage, getStorage, removeStorage, setAsyncStorage, setStorage } from './storage'
export { default as stringCompare } from './stringCompare'
export { default as swrCallbackMiddleware } from './swrCallbackMiddleware'
export {
  isValidCNPJ,
  isValidCPF,
  isValidTaxDocument,
  stripNonAlphanumeric,
  stripNonDigits
} from './taxDocument'
export { default as toBase64 } from './toBase64'
export { contactTypeUrl, getUrlString } from './url'
export { default as urlHostResolver } from './urlHostResolver'
export { default as Yup } from './yup'
export * as yupSchemas from './yupSchemas'
